import WalletDetail from "../../components/wallets/WalletDetail";

const WalletDetailPage: React.FC = () => <WalletDetail />;

export default WalletDetailPage;
